import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import FalconComponentCard from "components/common/FalconComponentCard";
import { Button, Col, Nav, Row, Form } from "react-bootstrap";
import PreauthorizationRequest from "./components/PreauthorizationRequest";
import BeneficiaryDetails from "./components/BeneficiaryDetails";
import { useForm } from "react-hook-form";
import TriageAssessment from "./components/TriageAssessment";
import { ageCalculator, getToday, ShowError, ShowWarning } from "helpers/utils";
import DiagnosisRequest from "./components/DiagnosisRequest";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ServicesProcedures from "./components/ServicesProcedures";
import {
  addValidationError,
  addValidationWarning,
  clearValidationErrors,
  clearValidationWarning,
  handlePreauthFormData,
  handleResetAll,
  setHistoryModal,
  setValidateError,
} from "./config/preauthorizationSlice";
import { AnimatePresence, motion } from "framer-motion";
import MedicalHistoryMOdal from "./components/MedicalHistoryModal";
import MedicalDetails from "./components/MedicalDetails";
import Encounter from "./components/Encounter";
import ClinicalDocumentation from "./components/ClinicalDocumentation";
import VerticalStepper from "./components/SteeperVertical";
import OpticalDetails from "./components/OpticalDetails";
import moment from "moment";
import WarningChild from "./components/WarningChild";
import { cleanObjectExcept, isEmpty } from "./utils";
import { SubmitPreauthorization } from "./config/preauthorizationApi";
import { useNavigate, useSearchParams } from "react-router-dom";
import { handleResetPatientSearch } from "features/eliglibility/eliglibility-check/config/eligibilityCheckSlice";
import { ViewSettings } from "features/field-settings/config/FieldSettingsApi";
import BackButton from "components/common/custom/back-button";
import paths from "routes/paths";

const Preauthorization = () => {
  const dispatch = useDispatch();

  const {
    preauthorizationDiagnosis,
    servicesList,
    historyModalOpen,
    stepFormData,
    validationErrors,
    encounterClass,
    discharegSpeciality,
    encounterStatusList,
    dischargeDispositionList,
    missingTeethList,
    validationWarning,
    labTestList,
    practitionerListAdded,
  } = useSelector((state) => state.preauthorization);

  const { singleEligibilityData } = useSelector(
    (state) => state.eligibilityCheckList
  );
  const { settingData } = useSelector((state) => state.settings);

  const navigate = useNavigate();

  const { allPermissionType } = useSelector((state) => state.role);
  const preauthorizationSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Preauthorization"
  );

  const [searchParams] = useSearchParams();
  const preauthId = searchParams.get("preauthid");
  const followUp = searchParams.get("followup") === "true";
  const reuse = searchParams.get("reuse") === "true";
  const edit = searchParams.get("edit") === "true";

  const {
    watch,
    setValue,
    handleSubmit,
    control,
    clearErrors,
    getFieldState,
    setError,
    formState: { errors, isSubmitted, touchedFields },
    reset,
    trigger,
  } = useForm({
    defaultValues: {
      payer: "",
      visit_reason: "",
      preauthorization_type: "",
      prescription: false,
      preauthorization_sub_type: "",
      priority_type: "",
      date: getToday(),
      visit_date: "",
      visit_time: "",
      healthcare_practitioner: "",
      practices: "",
      online_eligibility_ref_no: "",
      transferral: false,
      preauthorization_ref_no: "",
      referral_provider_practitioner: "",
      provider_name: "",
      prescription_ref_no: "",
      identifier_type: "",
      id_type: 1,
      id: "",
      patient_mrn: "",
      first_name: "",
      family_name: "",
      policy_no: "",
      policy_holder_name: "",
      relation_mrn: "",
      relation_id: "",
      birth_weight: "",
      class_name: "",
      relation_id_type: "",
      child_id_type: "",
      member_id: "",
      network: "",
      relation_relationship: "",
      relation_first_name: "",
      relation_family_name: "",
      relation_gender: "",
      relation_marital_status: "",
      relation_occupation: "",
      relation_religion: "",
      relation_birth_date: "",
      mobile_no: "",
      is_hijri: false,
      missing_tooth_date: "",
      birth_date: "",
      hijri_date_birth: "",
      gender: "",
      marital_status: "",
      occupation: "",
      relationship: "",
      religion: "",
      new_born: false,
      optical_date: getToday(),
      child_mrn: "",
      child_gender: "",
      child_birth_date: "",
      weight: "",
      admission_weight: "",
      height: "",
      pulse: "",
      systolic_blood_pressure: "",
      diastolic_blood_pressure: "",
      oxygen_saturation: "",
      respiratory_rate: "",
      heart_rhythm: "",
      chief_complaint: "",
      significant_sign: "",
      clinical_data: "",
      treatment_plan: "",
      patient_history: "",
      physical_examination: "",
      history_present_illness: "",
      icu_hours: "",
      ventilation_hours: "",
      snomed_code: "",
      admission_date: getToday(),
      discharge_date: "",
      triage_date: "",
      triage_category: "",
      encounter_class: "",
      encounter_status: "",
      care_type: "",
      encounter_admitsource: "",
      discharge_disposition: "",
      cause_of_death: "",
      act_priority: "",
      discharge_speciality: "",
      admission_speciality: "",
      emer_department_disposition: "",
      aspect_of_condition: "",
      offline: false,
      offline_eligibility_ref_no: "",
      accident_date: "",
      accident_type: "",
      address: "",
      street_name: "",
      city: "",
      country: "",
      offline_eligibility_date: "",
      aspect_date: "",
      aspect_end_date: "",
      readmission: "",
      emergency_arrival_code: "",
      emergency_service_start_date: "",
      last_menstrual_code: "",
      empoly_impact_start_date: "",
      empoly_impact_end_date: "",
      service_type: "",
      service_event_type: "",
      attachments: "",
      investgation_result_attachment: "",
      intend_length_stay: "",
      diagnosis_date: getToday(),
      estimated_length_stay: "",
      additional_information: "",
      investgation_result: "",
      investgation_result_others: "",
    },
    // shouldUnregister: false,
  });

  useEffect(() => {
    if (settingData?.length === 0) {
      dispatch(ViewSettings());
    }
  }, [settingData]);

  const [activeStep, setActiveStep] = useState(0);
  const [submit, setSubmit] = useState(false);

  const [showWarningModal, setShowWarningModal] = useState(false);

  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));

  watch("preauthorization_type")?.claim_types_name === "Vision";
  const isPharamacy =
    watch("preauthorization_type")?.claim_types_name === "Pharmacy";

  const isInstitual =
    stepFormData?.preauthorization_type?.claim_types_name === "Institutional";

  const isProfessionalOut =
    stepFormData?.preauthorization_type?.claim_types_name === "Professional" &&
    stepFormData?.preauthorization_sub_type?.visitreas_name === "OutPatient";
  const isProfessionalEmer =
    stepFormData?.preauthorization_type?.claim_types_name === "Professional" &&
    stepFormData?.preauthorization_sub_type?.visitreas_name === "Emergency";

  const isDental =
    stepFormData?.preauthorization_type?.claim_types_name === "Dental";
  const isVision =
    stepFormData?.preauthorization_type?.claim_types_name === "Vision";
  const isPrescription = watch("prescription");

  const isNCHI = stepFormData?.payer?.insurance_company_id === 41;

  const attachments = watch("attachments");
  const investigationAttachment = watch("investgation_result_attachment");

  const admissionDate = watch("admission_date");

  const dischargeDate = watch("discharge_date");

  const isEncounter = !isVision && !isPharamacy && !isPrescription;

  useEffect(() => {
    const hasPrincipal = preauthorizationDiagnosis?.some(
      (d) => d.type === "principal"
    );
    if (preauthorizationDiagnosis?.length > 0 && hasPrincipal) {
      dispatch(clearValidationErrors());
      clearErrors("diagnosis");
    }
  }, [preauthorizationDiagnosis, clearErrors, dispatch]);

  const calculateTotalAttachmentSize = (
    attachments,
    investigationAttachment
  ) => {
    let totalSize = 0;

    // Calculate size for general attachments
    if (Array.isArray(attachments)) {
      attachments.forEach((item) => {
        const base64Data = item?.valueAttachment?.data || "";
        if (base64Data) {
          // Remove base64 prefix (e.g., "data:image/png;base64,") if present
          const base64String = base64Data.split(",")[1] || base64Data;
          const binaryString = atob(base64String);
          totalSize += binaryString.length;
        }
      });
    }

    // Calculate size for investigation result attachment
    const invBase64 = investigationAttachment?.data || "";
    if (invBase64) {
      const base64String = invBase64.split(",")[1] || invBase64;
      const binaryString = atob(base64String);
      totalSize += binaryString.length;
    }

    return totalSize;
  };

  console.log({ servicesList });
  // -----------------------
  // Main function to build the full body
  const buildRequestBody = ({
    stepFormData,
    selectedBranch,
    practitionerListAdded,
    preauthorizationDiagnosis,
    labTestList,
    servicesList,
    isDental,
    isPharamacy,
    isPrescription,
  }) => {
    const buildEyePrescription = (side, type) => {
      const suffix = `_${type}`;
      const eyeLabel = side;

      const getField = (key) => stepFormData?.[`${side}_${key}${suffix}`] || "";
      const sphere = getField("sph");
      const power = getField("power");
      if (!sphere && !power) {
        return "";
      }

      const prismValues = [
        { amount: parseFloat(getField("in")) || "", base: "in" },
        { amount: parseFloat(getField("out")) || "", base: "out" },
        { amount: parseFloat(getField("down")) || "", base: "down" },
        { amount: parseFloat(getField("up")) || "", base: "up" },
      ].filter((p) => p.amount !== "" && p.amount !== 0);

      const prescription = {
        eye: eyeLabel,
        sphere: getField("sph"),
        cylinder: getField("cyl"),
        axis: getField("axis"),
        add: stepFormData?.[`${side}_add`] || "",
        brand: stepFormData?.[`${side}_brand`] || "",
        color: stepFormData?.[`${side}_color`] || "",
        power: getField("power"),
        duration: stepFormData?.[`${side}_duration_value`] || "",
        duration_typ: stepFormData?.[`${side}_duration_unit`] || "",
        bckcurve: getField("backcurve"),
        dmeter: getField("diameter"),
        prism: stepFormData?.productType === "lens" ? prismValues : [],
      };

      // 👇 Only add note if any of the "optical" fields are filled
      const hasNoteField = [
        prescription.sphere,
        prescription.power,
        prescription.cylinder,
        prescription.axis,
        ...prismValues.map((p) => p.amount),
        prescription.bckcurve,
        prescription.dmeter,
      ].some((val) => val !== "" && val !== undefined && val !== "");

      if (hasNoteField) {
        prescription.note = [{ text: type }];
      }

      // Remove if all values are ""/empty
      const hasRealData = Object.entries(prescription).some(([key, val]) => {
        if (key === "eye") return false;
        if (Array.isArray(val)) return val.length > 0;
        return val !== "" && val !== undefined && val !== "";
      });

      return hasRealData ? prescription : "";
    };

    const prescp = {
      lens_typ: stepFormData?.productType || "",
      prescp_dte:
        stepFormData?.productType && stepFormData?.optical_date
          ? moment(stepFormData?.optical_date).format("YYYY-MM-DD")
          : "",
      isframe:
        stepFormData?.productType === "lens" ? stepFormData?.is_frame : false,
      regular_lenses: stepFormData?.regularLenses,
      lens_specifications:
        stepFormData?.productType === "lens"
          ? stepFormData?.lens_specifications?.map((item) => item?.value)
          : "",
      regular_contact:
        stepFormData?.productType === "contact"
          ? stepFormData?.regular_contact
          : "",
    };

    const allPrescriptions = [
      buildEyePrescription("right", "distance"),
      buildEyePrescription("right", "near"),
      buildEyePrescription("left", "distance"),
      buildEyePrescription("left", "near"),
    ];

    // Dynamically add with keys starting from "1"
    let presIndex = 1;
    allPrescriptions.forEach((entry) => {
      if (entry) {
        prescp[presIndex.toString()] = entry;
        presIndex++;
      }
    });

    const sup_info = {
      18: { vreas: stepFormData?.visit_reason?.visitreas_code || "" },
      17: { chfcmp: { code: stepFormData?.chief_complaint || "" } },
      19: {
        invres: {
          code: stepFormData?.investgation_result?.investreslttype_code || "",
          oth: stepFormData?.investgation_result_others || "",
          contentType:
            stepFormData?.investgation_result_attachment?.contentType || "",
          title: stepFormData?.investgation_result_attachment?.title || "",
          creation:
            stepFormData?.investgation_result_attachment?.creation || "",
          data: stepFormData?.investgation_result_attachment?.data || "",
        },
      },
      20: { trtpln: stepFormData?.treatment_plan || "" },
      21: { pathistry: stepFormData?.patient_history || "" },
      22: { phyexmn: stepFormData?.physical_examination || "" },
      23: { histrypreill: stepFormData?.history_present_illness || "" },
      1: {
        systlc: isVision ? "" : stepFormData?.systolic_blood_pressure || "",
      },
      2: {
        diastlc: isVision ? "" : stepFormData?.diastolic_blood_pressure || "",
      },
      3: { wgt: isVision ? "" : stepFormData?.weight || "" },
      4: { hgt: isVision ? "" : stepFormData?.height || "" },
      5: { temp: isVision ? "" : stepFormData?.temperature || "" },
      10: { oxystrn: isVision ? "" : stepFormData?.oxygen_saturation || "" },
      12: { resprte: isVision ? "" : stepFormData?.respiratory_rate || "" },
      8: { plse: isVision ? "" : stepFormData?.pulse || "" },
      11: { brthwgt: isVision ? "" : stepFormData?.birth_weight || "" },
      6: {
        menstprd: stepFormData?.last_menstrual_code
          ? moment(stepFormData?.last_menstrual_code).format("YYYY-MM-DD")
          : "" || "",
      },
      7: { icuhrs: stepFormData?.icu_hours || "" },
      9: { vnthrs: stepFormData?.ventilation_hours || "" },
      14: {
        empimp: {
          stdate: stepFormData?.empoly_impact_start_date
            ? moment(stepFormData?.empoly_impact_start_date).format(
              "YYYY-MM-DD"
            )
            : "",
          eddate: stepFormData?.empoly_impact_end_date
            ? moment(stepFormData?.empoly_impact_end_date).format("YYYY-MM-DD")
            : "",
        },
      },
      15: { addinfo: stepFormData?.additional_information || "" },
      24: { admnwgt: isVision ? "" : stepFormData?.admission_weight || "" },
      13: { lgthsty: stepFormData?.estimated_length_stay || "" },
      16: {
        aspcnd: {
          code: stepFormData?.aspect_of_condition?.icd_code || "",
          dte: stepFormData?.aspect_date
            ? moment(stepFormData?.aspect_date).format("YYYY-MM-DD")
            : "",
        },
      },

      25: {
        morplgy: {
          code: stepFormData?.diagnosis_morphology?.morphology_code || "",
        },
      },
      26: {
        msngtooth: {
          code: stepFormData?.missing_tooth_number?.oral_code || "",
          dte: stepFormData?.missing_tooth_date
            ? moment(stepFormData?.missing_tooth_date).format("YYYY-MM-DD")
            : "",
          resncde: stepFormData?.missing_reason?.msngtoothcde_code || "",
        },
      },
      27: {
        Snomed: stepFormData?.snomed_code?.snomedcde_code || "",
      },
    };

    // Add lab tests into sup_info starting at key 27

    const body = {
      branch_id: selectedBranch?.branch_id || selectedBranch?.value || "",
      insurance_company_id: stepFormData?.payer?.insurance_company_id,
      claim_type: stepFormData?.preauthorization_type?.claim_types_id,
      claimsub_types_name:
        stepFormData?.preauthorization_sub_type?.claimsub_types_id,
      process_prior: stepFormData?.priority_type?.prcspri_code,
      patient_eligbid: !watch("offline")
        ? stepFormData?.online_eligibility_ref_no
        : "" || "",
      patient_eligbdte: !watch("offline")
        ? singleEligibilityData?.eligibility_response?.timestamp
          ? moment(
            singleEligibilityData?.eligibility_response?.timestamp
          ).format("YYYY-MM-DD")
          : ""
        : "" || "",
      patient_offeligbid: watch("offline")
        ? stepFormData?.offline_eligibility_ref_no
        : "" || "",
      patient_offeligbdte: watch("offline")
        ? stepFormData?.offline_eligibility_date
          ? moment(stepFormData?.offline_eligibility_date).format("DD-MM-YYYY")
          : ""
        : "",
      preauthid: followUp || edit ? preauthId : "" || "",
      reln_prior: followUp ? "prior" : "",
      referral_req: stepFormData?.preauthorization_ref_no || "",
      prescript_submt: stepFormData?.prescription ? true : "",

      patient_natid: stepFormData?.id || "",
      patient_finame: stepFormData?.first_name || "",
      prescp_no: stepFormData?.prescription_ref_no || "",
      patient_faname: stepFormData?.family_name || "",
      patient_dob: stepFormData?.birth_date
        ? moment(stepFormData?.birth_date).format("YYYY-MM-DD")
        : "",
      patient_mrn: stepFormData?.patient_mrn || "",
      patient_benf_benf_type:
        stepFormData?.relation_id_type?.ident_type_id ||
        stepFormData?.child_id_type?.ident_type_id ||
        "",
      idenf_type: stepFormData?.identifier_type?.ident_type_id || "",
      patient_gender: stepFormData?.gender?.genders_code || "",
      patient_marital: stepFormData?.marital_status?.maritalstatus_code || "",
      patient_profession:
        stepFormData?.profession?.occup_code ||
        stepFormData?.occupation?.occup_code ||
        "",
      patient_tel: stepFormData?.mobile_no || "",
      accident_date: stepFormData?.accident_date
        ? moment(stepFormData?.accident_date).format("YYYY-MM-DD")
        : "",
      accident_type: stepFormData?.accident_type?.accdnttype_code || "",
      accident_address:
        `${stepFormData?.address || ""}${stepFormData?.street_name || ""}${stepFormData?.city || ""
        }${stepFormData?.country || ""}` || "",
      patient_benf_gender: stepFormData?.new_born
        ? stepFormData?.child_gender?.genders_code
        : stepFormData?.relation_gender?.genders_code || "",
      patient_religion: stepFormData?.religion?.religion_code || "",
      patient_nationality: stepFormData?.nationality?.code || "",
      patient_plynum: stepFormData?.policy_no || "",
      patient_memid: stepFormData?.member_id || "",
      patient_ntwrkno: stepFormData?.network || "",
      patient_benf_finame: stepFormData?.new_born
        ? stepFormData?.child_first_name
        : stepFormData?.relation_first_name || "",
      clncldata: stepFormData?.clinical_data || "",
      patient_benf_faname: stepFormData?.new_born
        ? stepFormData?.child_family_name
        : stepFormData?.relation_family_name || "",
      clncldata: stepFormData?.clinical_data || "",
      patient_clsnme: stepFormData?.class_name || "",
      patient_benf_marital: stepFormData?.new_born
        ? ""
        : stepFormData?.relation_marital_status?.maritalstatus_code || "",
      patient_benf_religion: stepFormData?.new_born
        ? ""
        : stepFormData?.relation_religion?.religion_code || "",
      patient_benf_profession: stepFormData?.new_born
        ? ""
        : stepFormData?.relation_occupation?.occup_code || "",
      patient_benf_mrn: stepFormData?.new_born
        ? stepFormData?.child_mrn
        : stepFormData?.relation_mrn || "",
      patient_benf_dob: stepFormData?.new_born
        ? stepFormData?.child_birth_date
          ? moment(stepFormData?.child_birth_date).format("YYYY-MM-DD")
          : ""
        : stepFormData?.relation_birth_date
          ? moment(stepFormData?.relation_birth_date).format("YYYY-MM-DD")
          : "",
      clncldata: stepFormData?.clinical_data || "",
      patient_benf_id: stepFormData?.new_born
        ? stepFormData?.child_id
        : stepFormData?.relation_id || "",
      patient_polcyholdr: stepFormData?.policy_holder_name || "",
      patient_polcyholdrnum: stepFormData?.policy_holder_number || "",
      othrconditions: stepFormData?.other_conditions || "",
      prescrptn_refno: stepFormData?.preauthorization_ref_no || "",

      sgnfcntsign: stepFormData?.significant_sign || "",
      patient_relation: stepFormData?.relationship?.patrtl_code || "",
      patient_nwbrnrel: stepFormData?.new_born ? "child" : "",
      patient_nwbrnrel: stepFormData?.new_born ? "child" : "",
      new_brn: stepFormData?.new_born ? true : "",
      enct_cls: stepFormData?.encounter_class?.act_code || "",
      preauth_enctres: isEncounter ? "on" : "",
      sup_info,
      prescp,
      enct_stdate: isEncounter
        ? stepFormData?.admission_date
          ? moment(stepFormData?.admission_date).format("YYYY-MM-DD HH:mm:ss")
          : ""
        : "",
      enct_eddate: isEncounter
        ? stepFormData?.discharge_date
          ? moment(stepFormData?.discharge_date).format("YYYY-MM-DD HH:mm:ss")
          : ""
        : "",
      enct_serv_typ: isEncounter
        ? stepFormData?.care_type?.enctalltyp_code
        : "" || "",
      enct_prior: isEncounter
        ? stepFormData?.act_priority?.enctalltyp_code
        : "" || "",
      enct_emrgdeptdisp: isEncounter
        ? stepFormData?.emer_department_disposition?.enctalltyp_code
        : "" || "",
      enct_emrgarvlcde: isEncounter
        ? stepFormData?.emergncy_arrival_code?.enctalltyp_code
        : "" || "",
      enct_emergservst: isEncounter
        ? stepFormData?.emergency_service_start_date
          ? moment(stepFormData?.emergency_service_start_date).format(
            "YYYY-MM-DD"
          )
          : ""
        : "",
      enct_trgctg: isEncounter
        ? stepFormData?.triage_category?.enctalltyp_code
        : "" || "",
      patient_tel: stepFormData?.mobile_no || "",
      enct_trgdte: isEncounter
        ? stepFormData?.triage_date
          ? moment(stepFormData?.triage_date).format("YYYY-MM-DD")
          : ""
        : "",
      enct_hosp_intdlghsty: isEncounter
        ? stepFormData?.intend_length_stay?.enctalltyp_code
        : "" || "",
      enct_hosp_discgspeclty: isEncounter
        ? stepFormData?.discharge_speciality?.specialities_code
        : "" || "",
      enct_hosp_admnspeclty: isEncounter
        ? stepFormData?.admission_speciality?.specialities_code
        : "" || "",
      enct_adm_srce: isEncounter
        ? stepFormData?.encounter_admitsource?.enctalltyp_code
        : "" || "",
      enct_preadmn: isEncounter
        ? stepFormData?.readmission?.enctalltyp_code
        : "" || "",
      enct_disdisp: isEncounter
        ? stepFormData?.discharge_disposition?.enctalltyp_code
        : "" || "",
      enct_csedth: isEncounter ? stepFormData?.cause_of_death?.code : "" || "",
      enct_sevnttyp: isEncounter
        ? stepFormData?.service_event_type?.enctalltyp_code
        : "" || "",
      enct_status: isEncounter
        ? stepFormData?.encounter_status?.enctalltyp_code
        : "" || "",
      diag: {},
      prd_ser: {},
      sup_info_attch: {},
      sup_info_labt: {},
      sup_info_suply: {},
      preauth_submit: submit ? "preauth_submit" : "",
    };

    // Attachments
    if (Array.isArray(attachments)) {
      attachments?.forEach((item, index) => {
        body.sup_info_attch[index + 1] = {
          contentType: item?.valueAttachment?.contentType || "",
          title: item?.valueAttachment?.title || "",
          creation: item?.valueAttachment?.creation || "",
          data: item?.valueAttachment?.data || "",
        };
      });
    }

    const extractedSupInfoFields = [];

    // Extract from sup_info
    Object.entries(sup_info || {}).forEach(([_, fieldGroup]) => {
      if (!fieldGroup || typeof fieldGroup !== "object") return;

      Object.entries(fieldGroup).forEach(([fieldKey, fieldValue]) => {
        let hasValue = false;

        if (
          typeof fieldValue === "object" &&
          fieldValue !== null &&
          !Array.isArray(fieldValue)
        ) {
          hasValue = Object.values(fieldValue).some(
            (v) =>
              v !== null &&
              v !== undefined &&
              (typeof v !== "string" || v.trim() !== "")
          );
        } else {
          hasValue =
            fieldValue !== null &&
            fieldValue !== undefined &&
            (typeof fieldValue !== "string" || fieldValue.trim() !== "");
        }

        if (hasValue) {
          extractedSupInfoFields.push(fieldKey);
        }
      });
    });

    // Add attachment titles to extractedSupInfoFields
    if (Array.isArray(attachments)) {
      attachments?.forEach((item, index) => {
        const content = item?.valueAttachment || item || {};
        body.sup_info_attch[index + 1] = {
          contentType: content.contentType || "",
          title: content.title || "",
          creation: content.creation || "",
          data: content.data || "",
        };

        // 👇 Add title if present
        if (content.title && content.title.trim() !== "") {
          extractedSupInfoFields.push(content.title.trim());
        }
      });
    }

    // Practitioners
    if (
      Array.isArray(practitionerListAdded) &&
      practitionerListAdded.length > 0
    ) {
      const pract_id = {};
      practitionerListAdded.forEach((item, index) => {
        if (item.practitioner?.value) {
          const practitioner = {
            pract_id: item.practitioner.value.practitioner_id,
            pract_license: item.practitioner.value.practitioner_license,
            pract_name: `${item.practitioner.value.practitioner_title || ""} ${item.practitioner.value.practitioner_firstname || ""
              } ${item.practitioner.value.practitioner_familyname || ""}`.trim(),
            pract_finame:
              item?.practitioner?.value?.practitioner_firstname || "",
            pract_faname:
              item?.practitioner?.value?.practitioner_familyname || "",
            pract_spec: item?.practice?.label || "",
            pract_spec_code: item.practice?.value || "",
            role: item.role?.careroles_code || "",
          };
          if (!isEmpty(practitioner)) {
            pract_id[index + 1] = practitioner;
          }
        }
      });
      if (Object.keys(pract_id).length > 0) {
        body.pract_id = pract_id;
      }
    }

    // Diagnoses
    if (Array.isArray(preauthorizationDiagnosis)) {
      preauthorizationDiagnosis.forEach((item, index) => {
        const key = String(index + 1);
        body.diag[key] = {
          diag_code: item.code || "",
          diag_typ: item.type || "",
          on_adms: item.onAdmission || "",
          diag_onset: item?.condition_onset || "",
        };
      });
    }
    if (Array.isArray(labTestList)) {
      labTestList.forEach((test, index) => {
        const labt = {
          code: test?.lab_test_code?.loinc_code || "",
          uom: test?.lab_test_code?.loinc_uom || "",
          qty: test?.quantity || "",
        };
        const key = String(index + 1); // start from 1
        body.sup_info_labt[key] = labt;
      });
    }

    if (Array.isArray(servicesList)) {
      servicesList.forEach((item, index) => {
        const key = String(index + 1);
        if (
          item.day_supply !== null &&
          item.day_supply !== undefined &&
          item.day_supply !== ""
        ) {
          body.sup_info_suply[key] = item.day_supply;
        }
      });
    }

    // Services
    if (Array.isArray(servicesList)) {
      servicesList.forEach((item, index) => {
        const key = String(index + 1);
        const supInfoSupplyValue = body.sup_info_suply?.[key];

        body.prd_ser[key] = {
          prd_type: item?.service_type?.servtype_code || "",
          prd_code: item?.service_code_description?.prodserv_code || "",
          prd_descp_txt: item?.service_code_description?.prodserv_desc || "",
          prov_cde: item?.service_code_description?.provider_code || null,
          prd_url_txt: item?.service_code_description?.prdurl || "",
          prd_pri: item?.unit_price || "0",
          prd_qty: item?.quantity || "1",
          prd_namnt: item?.net_amount || "0",
          discnt: item?.discount || "0",
          prd_pshre: item?.patient_share || "0",
          diag_tax: item?.vat || "0",
          period: {
            start: item?.service_start_date
              ? moment(item?.service_start_date).format("YYYY-MM-DD")
              : "",
            end: item?.service_end_date
              ? moment(item?.service_end_date).format("YYYY-MM-DD")
              : "",
          },
          Sntfc_code: item?.scientific_code || "",
          strngth:
            item?.service_type?.servtype_code == "itm_prdt" || "itm_meddev"
              ? ""
              : item?.strength || "",
          slct_rsn: item?.selection_reason?.pharmselrsn_code || "",
          duration: {
            start: item?.start_date
              ? moment(item?.start_date).format("YYYY-MM-DD")
              : "",
            end: item?.end_date
              ? moment(item?.end_date).format("YYYY-MM-DD")
              : "",
            dur_time: item?.duration || "",
            dur_time_value: item?.durationType || item?.duration_type || "",
          },
          frequency: {
            frq: item?.frequency || "",
            frq_prd: item?.period_info || "",
            frq_time_value: item?.frequencyType || item?.period_type || "",
          },
          dose: {
            dsg_prd: "",
            dsg_time_value: item?.dose || "",
            dsg_inst: item?.doseType || item?.dose_type || "",
          },
          ROA: item?.route?.ruteadmn_code || "",
          ROA_disp: item?.route?.ruteadmn_name || "",
          time_inst: item?.time_instruction?.time_instCode || "",
          time_inst_disp: item?.time_instruction?.time_instDisplay || "",
          refill_count: item?.refill_count || "",
          pat_inst: item?.patient_instruction || "",
          dosage_instruction: item?.dosage_instruction || "",
          prd_packg: item?.packaged || false,
          prd_mtrnty: item?.maternity || false,
          orl_reg_code: isDental ? item?.oral_origin?.oral_code : "",
          body_site: !isDental ? item?.body_site?.bodysite_code : "",
          orl_reg_subsite: item?.sub_site?.bodysubsite_code || "",

          nonstd_cde: "",
          nonstd_disp: "",
          pres_med: {
            type: item?.prescribed_medication_type?.servtype_code || "",
            code: item?.prescribed_medication_code?.prodserv_code || "",
            url: item?.prescribed_medication_code?.prdurl || "",
          },
          Sntfc_code_abs_rsn: item?.scientic_code_absence?.absrsn_code || "",
          Sntfc_code_abs_rsn_oth: item?.scientific_code_other_reason || "",
          pselrsn: item?.selection_reason?.pharmselrsn_code || "",
          pharsubs: item?.pharmacist_substitute?.subsrsn_code || "",
          pharsubsrsn: item?.substitute_reason_other || "",
          pract: [
            item?.service_practitioner?.value?.practitioner_license?.toString() ||
            item?.service_practitioner?.value?.practitioner_id?.toString() ||
            item?.service_practitioner?.practitioner_id,
          ],
          supinfo: extractedSupInfoFields || [],
          diag: item?.diagnosis?.map((d) => d.code) || [],
          supinfo3:
            supInfoSupplyValue != null && supInfoSupplyValue !== ""
              ? [`Days Supply-${key}`]
              : [],
          supinfo1: item?.lab_tests?.map((t) => t?.loinc_code) || [],
        };
      });
    }

    //  Return cleaned body — except sup_info
    return cleanObjectExcept(body, ["sup_info"]);
  };

  const steps = [
    {
      label: "Pre-authorization Request",
      component: PreauthorizationRequest,
      props: {
        watch,
        setValue,
        errors,
        control,
        setError,
        clearErrors,
        touchedFields,
      },
    },
    {
      label: "Beneficiary Details",
      component: BeneficiaryDetails,
      props: {
        control,
        watch,
        errors,
        isSubmitted,
        setValue,
        reset,
        clearErrors,
        touchedFields,
      },
    },
    // Institutional condition

    isVision
      ? {
        label: "Optical Details",
        component: OpticalDetails,
        props: { control, watch, setValue, touchedFields },
      }
      : {
        label: "Triage Assessment",
        component: TriageAssessment,
        props: { control, watch, setValue, getFieldState },
      },

    {
      label: "Diagnosis",
      component: DiagnosisRequest,
      props: {
        watch,
        control,
        setValue,
        activeStep,
        setError,
        clearErrors,
        touchedFields,
      },
    },
    {
      label: "Services & Procedures",
      component: ServicesProcedures,
      props: { watch, control, setActiveStep, setValue, setError },
    },
    !isPrescription && {
      label: "Medical Details",
      component: MedicalDetails,
      props: { watch, control, setValue },
    },
    !isVision &&
    !isPharamacy &&
    !isPrescription && {
      label: "Encounter",
      component: Encounter,
      props: {
        watch,
        control,
        setValue,
        setError,
        clearErrors,
        getFieldState,
      },
    },
    {
      label: "Clinical Documentation",
      component: ClinicalDocumentation,
      props: { watch, control, setValue, clearErrors, setError },
    },
  ].filter(Boolean);

  const ageCond = stepFormData?.new_born
    ? stepFormData?.child_birth_date
    : stepFormData?.relationship?.patrtl_code !== "self"
      ? stepFormData?.relation_birth_date
      : stepFormData?.birth_date;

  const { age } = ageCalculator(ageCond);

  const genderCond = stepFormData?.new_born
    ? stepFormData?.child_gender
    : stepFormData?.relationship?.patrtl_code !== "self"
      ? stepFormData?.relation_gender
      : stepFormData?.gender;

  const isLastStep = activeStep === steps.length - 1;
  const handleNext = async (data) => {
    dispatch(clearValidationErrors());
    clearErrors();

    dispatch(handlePreauthFormData({ check: "save", data }));

    const currentStep = steps[activeStep];

    // Store validation state locally
    let shouldBlock = false;

    if (currentStep?.label === "Pre-authorization Request" && isNCHI) {
      if (
        watch("preauthorization_type")?.claim_types_name !== "Institutional"
      ) {
        dispatch(
          addValidationError({
            field: "preauthorization",
            message: "[CNHI Rule] Type must be Institutional",
          })
        );
        shouldBlock = true;
      }
      if (watch("preauthorization_sub_type")?.visitreas_name !== "InPatient") {
        dispatch(
          addValidationError({
            field: "preauthorization",
            message: "[CNHI Rule] Type must be Institutional",
          })
        );
        shouldBlock = true;
      }

      if (
        watch("visit_reason") &&
        watch("visit_reason").visitreas_name !== "Referral"
      ) {
        dispatch(
          addValidationError({
            field: "Visit reason",
            message:
              "[CNHI Rule] Visit Reason must be referral, or leave it empty in case of emergency",
          })
        );
        shouldBlock = true;
      }

      if (
        watch("visit_reason")?.visitreas_name === "Referral" &&
        watch("preauthorization_ref_no") === ""
      ) {
        dispatch(
          addValidationError({
            field: "Preauthorization Ref No",
            message: "[CNHI Rule] Preauthorization Ref No Mandatory",
          })
        );
        shouldBlock = true;
      }
    }

    if (currentStep?.label === "Pre-authorization Request") {
      // Check for multiple primary roles
      practitionerListAdded.forEach((practitioner, index) => {
        const entryNumber = index + 1;

        // Check practitioner
        if (!practitioner.practitioner?.value?.practitioner_id) {
          dispatch(
            addValidationError({
              field: `Practitioner #${entryNumber}`,
              message: `[Validation] Practitioner is required in entry ${entryNumber}`,
            })
          );
          shouldBlock = true;
        }

        // Check practice
        if (!practitioner.practice?.value) {
          dispatch(
            addValidationError({
              field: `Practice #${entryNumber}`,
              message: `[Validation] Practice is required in entry ${entryNumber}`,
            })
          );
          shouldBlock = true;
        }

        // Check role
        if (!practitioner.role?.careroles_code) {
          dispatch(
            addValidationError({
              field: `Role #${entryNumber}`,
              message: `[Validation] Role is required in entry ${entryNumber}`,
            })
          );
          shouldBlock = true;
        }
      });

      const primaryCount = practitionerListAdded.filter(
        (p) => p.role?.careroles_code?.toLowerCase() === "primary"
      ).length;

      if (primaryCount > 1) {
        dispatch(
          addValidationError({
            field: "Practitioner Roles",
            message: "[Validation] Only one primary practitioner allowed",
          })
        );
        shouldBlock = true;
      }

      if (practitionerListAdded?.length === 0) {
        dispatch(
          addValidationError({
            field: "Practitioner ",
            message: "One Doctor Must be added",
          })
        );
        shouldBlock = true;
      }

      // Check for duplicate practitioners
      const practitionerIds = {};
      practitionerListAdded.forEach((p) => {
        const id = p.practitioner?.value?.practitioner_id;
        if (id) {
          practitionerIds[id] = (practitionerIds[id] || 0) + 1;
        }
      });

      const duplicates = Object.entries(practitionerIds)
        .filter(([_, count]) => count > 1)
        .map(([id]) => id);

      if (duplicates.length > 0) {
        dispatch(
          addValidationError({
            field: "Healthcare Practitioners",
            message: "[Validation] Duplicate practitioners detected",
          })
        );
        shouldBlock = true;
      }
    }

    // Diagnosis validation
    if (currentStep?.label === "Diagnosis") {
      const hasDiagnosis = preauthorizationDiagnosis?.length > 0;
      const hasPrincipalDiagnosis = preauthorizationDiagnosis?.some(
        (diagnosis) => diagnosis.type === "principal"
      );

      const principalsDiagnosis = preauthorizationDiagnosis?.filter(
        (item) => item?.type === "principal"
      );

      const PDXPrinciple = preauthorizationDiagnosis?.some(
        (item) => item.UnacceptPDx === "1" && item?.type === "principal"
      );

      // New morphology validation
      const hasMorphology = watch("diagnosis_morphology");
      const accidentType = watch("accident_type.accdnttype_code");
      const hasY96 = preauthorizationDiagnosis?.some((d) => d.code === "Y96");

      const hasRTADiag = preauthorizationDiagnosis?.some(
        (d) => d?.RTA_diag === "1"
      );

      if (stepFormData?.new_born) {
        const validBirthCodes = [
          "Z38.0",
          "Z38.1",
          "Z38.2",
          "Z38.3",
          "Z38.4",
          "Z38.5",
          "Z38.6",
          "Z38.7",
          "Z38.8",
        ];

        const hasValidBirthDiagnosis = preauthorizationDiagnosis?.some(
          (d) => d.type === "secondary" && validBirthCodes.includes(d.code)
        );

        if (!hasValidBirthDiagnosis) {
          dispatch(
            addValidationError({
              field: "diagnosis",
              message:
                "Birth Related diagnosis with type secondary is required when Newborn selected.",
            })
          );
          shouldBlock = true;
        }
      }

      const getPatientCode = (age) => {
        const { years, months, days } = age;

        if (years > 0) {
          if (years >= 100) return 300 + (years - 100); // 300–324
          return 200 + years; // 201–299
        } else if (months > 0) {
          return 100 + months; // 101–111
        } else if (days > 0) {
          if (days <= 6) return days; // 000–006
          const weeks = Math.floor(days / 7);
          if (weeks >= 1 && weeks <= 3) return 10 + weeks; // 011–013
        }
        return 0; // Default to 0 (newborn)
      };

      const ageInfo = {
        years: age?.years || 0,
        months: age?.months || 0,
        days: age?.days || 0,
      };

      const patientCode = getPatientCode(ageInfo);
      const isInstitutional =
        stepFormData?.preauthorization_type?.claim_types_name ===
        "Institutional";

      if (!isInstitutional) {
        const invalidDiagnosisTypes = preauthorizationDiagnosis?.some(
          (d) => d.type === "admitting" || d.type === "discharge"
        );

        if (invalidDiagnosisTypes) {
          dispatch(
            addValidationError({
              field: "diagnosis",
              message:
                "Admitting/Discharge diagnosis types cannot be used in non-Institutional preauthorization",
            })
          );
          shouldBlock = true;
        }
      }

      // Rule 1: Y96 requires WPA accident type
      if (hasY96 && accidentType !== "WPA") {
        dispatch(
          addValidationError({
            field: "accident_type",
            message:
              "Diagnosis code Y96 requires Workplace Accident (WPA) type",
          })
        );
        shouldBlock = true;
      }

      if (accidentType === "WPA" && !hasY96) {
        dispatch(
          addValidationError({
            field: "diagnosis",
            message:
              "Workplace Accident (WPA) type must have Diagnosis code Y96",
          })
        );
        shouldBlock = true;
      }

      if (hasRTADiag && accidentType !== "MVA") {
        dispatch(
          addValidationError({
            field: "diagnosis",
            message:
              "One of the Diagnosis (principal/Secondary) need reporting Accident type 'Motor Vehicle Accident'",
          })
        );
        shouldBlock = true;
      }

      if (!hasRTADiag && accidentType === "MVA") {
        dispatch(
          addValidationError({
            field: "diagnosis",
            message:
              "Motor Vehicle Accident (MVA) type must have Diagnosis  related with Road Traffic Accident",
          })
        );
        shouldBlock = true;
      }

      if (PDXPrinciple) {
        const invalidDiagnosis = preauthorizationDiagnosis.find(
          (item) => item.UnacceptPDx === "1" && item?.type === "principal"
        );
        const diagnosisCode = invalidDiagnosis?.code || "Invalid Code";

        dispatch(
          addValidationError({
            field: "diagnosis",
            message: `Diagnosis code ${diagnosisCode} cannot be selected as Principal.`,
          })
        );
        shouldBlock = true;
      }

      if (!hasDiagnosis) {
        dispatch(
          addValidationError({
            field: "diagnosis",
            message: "Please add at least one diagnosis",
          })
        );
        shouldBlock = true;
      } else if (!hasPrincipalDiagnosis) {
        dispatch(
          addValidationError({
            field: "diagnosis",
            message: "One Diagnosis code with type Principal is required.",
          })
        );
        shouldBlock = true;
      } else if (principalsDiagnosis?.length > 1) {
        dispatch(
          addValidationError({
            field: "diagnosis",
            message: "Only One Diagnosis with Principle is allowed",
          })
        );
        shouldBlock = true;
      }

      // Check for duplicate diagnosis codes
      const diagnosisCodes = {};
      preauthorizationDiagnosis.forEach((d) => {
        const code = d.code;
        if (code) {
          diagnosisCodes[code] = (diagnosisCodes[code] || 0) + 1;
        }
      });

      const duplicateDiags = Object.entries(diagnosisCodes)
        .filter(([_, count]) => count > 1)
        .map(([code]) => code);

      if (duplicateDiags.length > 0) {
        dispatch(
          addValidationError({
            field: "diagnosis",
            message: `Each diagnosis must be unique. The following duplicate diagnosis codes were found: ${duplicateDiags.join(", ")}`,
          })
        );
        shouldBlock = true;
      }

      if (hasMorphology) {
        const hasValidMorphCode = preauthorizationDiagnosis?.some(
          (d) =>
            (d.type === "principal" || d.type === "secondary") &&
            d?.Morph_Code === "1"
        );

        if (!hasValidMorphCode) {
          dispatch(
            addValidationError({
              field: "diagnosis",
              message:
                "Morphology related diagnosis code with type principal/secondary is required when Morphology Code given.",
            })
          );
          shouldBlock = true;
        }
      }
      preauthorizationDiagnosis?.forEach((diagnosis) => {
        const ageL = parseInt(diagnosis?.AgeL, 10);
        const ageH = parseInt(diagnosis?.AgeH, 10);
        const pationAType = diagnosis?.Atype == "2";
        const patienSType = diagnosis?.Stype == "2";
        const isMale = diagnosis?.sex === "1";
        const isFemale = diagnosis?.sex === "2";

        if (!isNaN(ageL) && patientCode < ageL) {
          if (pationAType) {
            dispatch(
              addValidationWarning({
                code: diagnosis?.code,
                message: "This Diagnosis Cannot be used for patient this age.",
              })
            );
            // shouldBlock = true;
            // toast.warn("This Diagnosis Cannot be used for patient this age.");
          } else {
            dispatch(
              addValidationError({
                field: "diagnosis",
                message: "This Diagnosis Cannot be used for patient this age.",
              })
            );
            shouldBlock = true;
          }
        }
        // Both backcurve distance and diameter distance must be provided together

        if (!isNaN(ageH) && patientCode > ageH) {
          if (pationAType) {
            dispatch(
              addValidationWarning({
                code: diagnosis?.code,

                message: "This Diagnosis is rare to use with this patient age.",
              })
            );
            // shouldBlock = true;
          } else {
            dispatch(
              addValidationError({
                field: "diagnosis",
                message: "This Diagnosis Cannot be used for patient this age.",
              })
            );
            shouldBlock = true;
          }
        }

        if (genderCond?.genders_disply == "Male" && isFemale) {
          if (patienSType) {
            dispatch(
              addValidationWarning({
                code: diagnosis?.code,

                message:
                  "This Diagnosis is rare to use with this patient Type.",
              })
            );
            // shouldBlock = true;
          } else {
            console.log({ patienSType });
            dispatch(
              addValidationError({
                field: "diagnosis",
                message: "Diagnosis can't be used for Male patient",
              })
            );
            shouldBlock = true;
          }
        }

        if (genderCond?.genders_disply === "Female" && isMale) {
          if (patienSType) {
            dispatch(
              addValidationWarning({
                code: diagnosis?.code,

                message:
                  "This Diagnosis is rare to use with this patient Type.",
              })
            );
            // shouldBlock = true;
          } else {
            dispatch(
              addValidationError({
                field: "diagnosis",
                message: "Diagnosis can't be used for Female patient",
              })
            );
            shouldBlock = true;
          }
        }
      });
    }

    if (currentStep?.label === "Medical Details") {
      if (watch("aspect_of_condition") && !watch("aspect_date")) {
        dispatch(
          addValidationError({
            field: "aspect_date",
            message: "Aspect Start Date is Required",
          })
        );
        shouldBlock = true;
      }
    }
    if (currentStep?.label === "Optical Details" && isVision) {
      const productType = watch("productType");

      // Implemented validation: both fields must be present or both absent
      const validateFieldPairs = (cylField, axisField) => {
        const cylValue = watch(cylField);
        const axisValue = watch(axisField);

        // If one is present but the other is missing
        if ((cylValue && !axisValue) || (!cylValue && axisValue)) {
          dispatch(
            addValidationError({
              field: cylValue ? axisField : cylField,
              message: `Both ${cylField
                .split("_")
                .slice(1)
                .join(" ")} and ${axisField
                  .split("_")
                  .slice(1)
                  .join(" ")} must be provided together`,
            })
          );
          return false;
        }

        return true;
      };

      if (productType === "lens") {
        // SPHERE validation - require at least one
        const hasAnySphere = [
          "left_sph_distance",
          "left_sph_near",
          "right_sph_distance",
          "right_sph_near",
        ].some((field) => watch(field) != null && watch(field) !== "");

        if (!hasAnySphere) {
          dispatch(
            addValidationError({
              field: "sph",
              message: "Sphere is required for at least one eye/distance",
            })
          );
          shouldBlock = true;
        }

        // CYL + AXIS validation
        const cylinderAxisPairs = [
          ["left_cyl_distance", "left_axis_distance"],
          ["left_cyl_near", "left_axis_near"],
          ["right_cyl_distance", "right_axis_distance"],
          ["right_cyl_near", "right_axis_near"],
        ];
        for (const [cyl, axis] of cylinderAxisPairs) {
          const cylValue = watch(cyl);
          const axisValue = watch(axis);

          // If only one is filled → handled by validateFieldPairs
          if (!validateFieldPairs(cyl, axis)) {
            shouldBlock = true;
          }

          // Only check sphere if cyl or axis is non-empty/non-null
          const hasCylOrAxis =
            (cylValue != null && cylValue !== "") ||
            (axisValue != null && axisValue !== "");
          if (hasCylOrAxis) {
            const [side, , type] = cyl.split("_");
            const sphereField = `${side}_sph_${type}`;
            const powerField = `${side}_power_${type}`;

            const sphValue = watch(sphereField);

            if (sphValue == null || sphValue === "") {
              dispatch(
                addValidationError({
                  field: sphereField,
                  message: `Sphere is required when Cylinder or Axis is provided (${side} ${type})`,
                })
              );
              shouldBlock = true;
            }
          }
        }

        // Directional prism validation
        const directions = ["in", "out", "up", "down"];
        const sides = ["left", "right"];
        const types = ["distance", "near"];

        for (const direction of directions) {
          for (const side of sides) {
            for (const type of types) {
              const dirField = `${side}_${direction}_${type}`;
              const sphField = `${side}_sph_${type}`;
              const dirValue = watch(dirField);
              const sphValue = watch(sphField);

              // Only check sphere if directional prism is non-empty/non-null
              if (
                dirValue != null &&
                dirValue !== "" &&
                (sphValue == null || sphValue === "")
              ) {
                dispatch(
                  addValidationError({
                    field: sphField,
                    message:
                      "Sphere is required when directional prism is specified",
                  })
                );
                shouldBlock = true;
              }
            }
          }
        }
      }

      if (productType === "contact") {
        // POWER validation
        const hasAnyPower = [
          "left_power_distance",
          "left_power_near",
          "right_power_distance",
          "right_power_near",
        ].some((field) => watch(field) != null && watch(field) !== "");

        if (!hasAnyPower) {
          dispatch(
            addValidationError({
              field: "power",
              message: "Power is required for at least one eye/distance",
            })
          );
          shouldBlock = true;
        }

        // CYL + AXIS validation
        const cylinderAxisPairs = [
          ["left_cyl_distance", "left_axis_distance"],
          ["left_cyl_near", "left_axis_near"],
          ["right_cyl_distance", "right_axis_distance"],
          ["right_cyl_near", "right_axis_near"],
        ];

        for (const [cyl, axis] of cylinderAxisPairs) {
          const cylValue = watch(cyl);
          const axisValue = watch(axis);

          // If only one is filled → handled by validateFieldPairs
          if (!validateFieldPairs(cyl, axis)) {
            shouldBlock = true;
          }

          // Only check power if cyl or axis is non-empty/non-null
          const hasCylOrAxis =
            (cylValue != null && cylValue !== "") ||
            (axisValue != null && axisValue !== "");
          if (hasCylOrAxis) {
            const [side, , type] = cyl.split("_");
            const powerField = `${side}_power_${type}`;

            const powerValue = watch(powerField);

            if (powerValue == null || powerValue === "") {
              dispatch(
                addValidationError({
                  field: powerField,
                  message: `Power is required when Cylinder or Axis is provided (${side} ${type})`,
                })
              );
              shouldBlock = true;
            }
          }
        }

        // Backcurve and Diameter validation
        const directions = ["backcurve", "diameter"];
        const sides = ["left", "right"];
        const types = ["distance", "near"];

        for (const direction of directions) {
          for (const side of sides) {
            for (const type of types) {
              const dirField = `${side}_${direction}_${type}`;
              const powerField = `${side}_power_${type}`;
              const dirValue = watch(dirField);
              const powerValue = watch(powerField);

              // Only check power if backcurve or diameter is non-empty/non-null
              if (
                dirValue != null &&
                dirValue !== "" &&
                (powerValue == null || powerValue === "")
              ) {
                dispatch(
                  addValidationError({
                    field: powerField,
                    message: `Power is required when ${direction.charAt(0).toUpperCase() + direction.slice(1)
                      } is specified`,
                  })
                );
                shouldBlock = true;
              }
            }
          }
        }
      }
    }

    if (currentStep?.label === "Encounter") {
      const admissionDate = watch("admission_date");

      // ✅ Employee impact dates validation
      const empStart = data.empoly_impact_start_date
        ? new Date(data.empoly_impact_start_date)
        : null;
      const empEnd = data.empoly_impact_end_date
        ? new Date(data.empoly_impact_end_date)
        : null;

      if (empStart && empEnd) {
        empStart.setHours(0, 0, 0, 0);
        empEnd.setHours(0, 0, 0, 0);

        if (empEnd < empStart) {
          dispatch(
            addValidationError({
              field: "empoly_impact_end_date",
              message:
                "Employee impact end date must be on or after start date",
            })
          );
          shouldBlock = true;
        }
      }

      // ✅ Admission date within service start/end
      if (
        admissionDate &&
        Array.isArray(servicesList) &&
        servicesList.length > 0
      ) {
        let earliestStartDate = null;
        let latestEndDate = null;

        const normalizeDate = (d) => {
          if (!d) return null;

          if (d instanceof Date) {
            return new Date(d.getFullYear(), d.getMonth(), d.getDate());
          }

          if (typeof d === "string") {
            const parts = d.split("-");

            if (parts.length === 3) {
              if (parts[0].length === 4) {
                return new Date(
                  parseInt(parts[0]),
                  parseInt(parts[1]) - 1,
                  parseInt(parts[2])
                );
              } else {
                return new Date(
                  parseInt(parts[2]),
                  parseInt(parts[1]) - 1,
                  parseInt(parts[0])
                );
              }
            }
          }

          return null;
        };

        const admission = normalizeDate(admissionDate);
        const discharge = dischargeDate ? normalizeDate(dischargeDate) : null;

        servicesList.forEach((service) => {
          const startDate = normalizeDate(service?.service_start_date);
          const endDate = normalizeDate(service?.service_end_date);

          console.log({ servicesList });

          if (startDate) {
            if (!earliestStartDate || startDate < earliestStartDate) {
              earliestStartDate = startDate;
            }
          }

          if (endDate) {
            if (!latestEndDate || endDate > latestEndDate) {
              latestEndDate = endDate;
            }
          }
        });

        const formatDate = (date) =>
          date ? moment(date).format("DD-MM-YYYY") : "N/A";

        if (earliestStartDate && admission > earliestStartDate) {
          dispatch(
            addValidationError({
              field: "admission_date",
              message: `Admission date must be on or before the earliest service start date: ${formatDate(
                earliestStartDate
              )}`,
            })
          );
          shouldBlock = true;
        }

        if (discharge && latestEndDate && discharge < latestEndDate) {
          dispatch(
            addValidationError({
              field: "discharge_date",
              message: `Discharge date must be on or after the latest service end date: ${formatDate(
                latestEndDate
              )}`,
            })
          );
          shouldBlock = true;
        }
      }
    }

    // Services validation
    if (
      currentStep?.label === "Services & Procedures" &&
      servicesList?.length === 0
    ) {
      dispatch(
        addValidationError({
          field: "services",
          message: "Please add at least one service",
        })
      );
      shouldBlock = true;
    }
    if (currentStep?.label === "Services & Procedures") {
      if (admissionDate && Array.isArray(servicesList)) {
        const normalizedAdmission = new Date(admissionDate);
        normalizedAdmission.setHours(0, 0, 0, 0);

        const normalizedDischarge = dischargeDate
          ? new Date(dischargeDate)
          : null;
        if (normalizedDischarge) normalizedDischarge.setHours(0, 0, 0, 0);

        // servicesList.forEach((service, index) => {
        //   if (!service?.service_start_date) return;

        //   const serviceDate = new Date(service.service_start_date);
        //   serviceDate.setHours(0, 0, 0, 0);

        //   const isBeforeAdmission = serviceDate < normalizedAdmission;
        //   const isAfterDischarge =
        //     normalizedDischarge && serviceDate > normalizedDischarge;

        //   if (isBeforeAdmission || isAfterDischarge) {
        //     dispatch(
        //       addValidationError({
        //         field: `services[${index}].service_start_date`,
        //         message: normalizedDischarge
        //           ? "Service date must be between admission and discharge dates"
        //           : "Service date must be after admission date",
        //       })
        //     );
        //     shouldBlock = true;
        //   }
        // });
      }
    }

    // ID validation - Fixed condition
    if (currentStep?.label === "Beneficiary Details") {
      const id = watch("id");
      const identifierType = watch("identifier_type")?.ident_type_code?.toLowerCase();

      console.log({ identifierType })

      const firstChar = id?.charAt(0);
      const isChildRelationShip =
        watch("relationship")?.patrtl_name?.toLowerCase() == "child";
      const isNewBorn = watch("new_born");
      const relationID = watch("relation_id");
      const relationType = watch("relation_id_type")?.ident_type_code?.toLowerCase();
      const firstCharRelation = relationID?.charAt(0);
      const childID = watch("child_id");
      const childType = watch("child_id_type")?.ident_type_code?.toLowerCase();
      const firstCharchild = childID?.charAt(0);

      if (isChildRelationShip && !isNewBorn) {
        if (!relationID) {
          dispatch(
            addValidationError({
              field: "relation id",
              message: "Please enter relation ID or relation Iqama No.",
            })
          );
          shouldBlock = true;
        } else if (relationType == "prc" && firstCharRelation !== "2") {
          dispatch(
            addValidationError({
              field: "id",
              message: "Iqama No. must start with 2",
            })
          );
          shouldBlock = true;
        } else if (relationType == "ni" && firstCharRelation !== "1") {
          dispatch(
            addValidationError({
              field: "id",
              message: "National ID No. must start with 1",
            })
          );
          shouldBlock = true;
        } else if (
          (relationType == "prc" || relationType == "ni") &&
          relationID?.length !== 10
        ) {
          dispatch(
            addValidationError({
              field: "id",
              message: "Relation ID/Iqama must be 10 digits",
            })
          );
          shouldBlock = true;
        } else if (
          relationType != "prc" &&
          relationType != "ni" &&
          ["1", "2"].includes(firstCharRelation)
        ) {
          dispatch(
            addValidationError({
              field: "id",
              message:
                "ID format does not match: Only National ID or Iqama should start with 1 or 2",
            })
          );
          shouldBlock = true;
        }
      }

      if (isNewBorn) {
        if (childType == "prc" && firstCharchild !== "2") {
          dispatch(
            addValidationError({
              field: "id",
              message: "Iqama No. must start with 2",
            })
          );
          shouldBlock = true;
        } else if (childType == "ni" && firstCharchild !== "1") {
          dispatch(
            addValidationError({
              field: "id",
              message: "National ID No. must start with 1",
            })
          );
          shouldBlock = true;
        } else if (
          (childType == "prc" || childType == "ni") &&
          childID?.length !== 10
        ) {
          dispatch(
            addValidationError({
              field: "id",
              message: "Relation ID/Iqama must be 10 digits",
            })
          );
          shouldBlock = true;
        } else if (
          childType != "prc" &&
          childType != "ni" &&
          ["1", "2"].includes(firstCharchild)
        ) {
          dispatch(
            addValidationError({
              field: "id",
              message:
                "ID format does not match: Only National ID or Iqama should start with 1 or 2",
            })
          );
          shouldBlock = true;
        }
      }

      if (!id) {
        dispatch(
          addValidationError({
            field: "id",
            message: "Please enter ID or Iqama No.",
          })
        );
        shouldBlock = true;
      } else if (identifierType == "prc" && firstChar !== "2") {
        dispatch(
          addValidationError({
            field: "id",
            message: "Iqama No. must start with 2",
          })
        );
        shouldBlock = true;
      } else if (identifierType == "ni" && firstChar !== "1") {
        dispatch(
          addValidationError({
            field: "id",
            message: "National ID No. must start with 1",
          })
        );
        shouldBlock = true;
      } else if (
        (identifierType == "ni" || identifierType == "prc") &&
        id.length !== 10
      ) {
        dispatch(
          addValidationError({
            field: "id",
            message: "ID/Iqama must be 10 digits",
          })
        );
        shouldBlock = true;
      } else if (
        identifierType != "prc" &&
        identifierType != 'ni' &&
        ["1", "2"].includes(firstChar)
      ) {
        dispatch(
          addValidationError({
            field: "id",
            message:
              "ID format does not match: Only National ID or Iqama should start with 1 or 2",
          })
        );
        shouldBlock = true;
      }
    }

    if (currentStep?.label === "Clinical Documentation") {
      const totalSize = calculateTotalAttachmentSize(
        attachments,
        investigationAttachment
      );
      const maxSizeBytes = 10 * 1024 * 1024; // 10MB

      if (totalSize > maxSizeBytes) {
        dispatch(
          addValidationError({
            field: "attachments",
            message:
              "The total size of all attachments and investigation result exceeds the maximum limit of 10MB. Please compress your files or remove some attachments to proceed.",
          })
        );
        shouldBlock = true;
      }

      const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
      if (watch("investgation_result_attachment")?.size > 10 * 1024 * 1024) {
        dispatch(
          addValidationError({
            field: "investgation_result_attachment",
            message: "The file Can't be more 10 Mb",
          })
        );
        shouldBlock = true;
      }
    }

    if (shouldBlock) return;

    const currentStepFields = steps[activeStep].fields || [];
    const isValid = await trigger(currentStepFields);

    if (isValid) {
      if (isLastStep) {
        try {
          // 3. Build fresh request body with latest data
          const requestBody = buildRequestBody({
            stepFormData: data, // Use form data from react-hook-form
            selectedBranch,
            attachments: watch("attachments"),
            practitionerListAdded,
            preauthorizationDiagnosis,
            labTestList,
            servicesList,
            isDental,
            isPharamacy,
            isPrescription,
          });

          // console.log({ requestBody });
          // return;

          const response = await dispatch(
            SubmitPreauthorization(requestBody)
          ).unwrap();

          if (response?.status_code === "200") {
            toast.success(response?.message_en);
            dispatch(handleResetAll({ check: "reset" }));
            dispatch(handleResetPatientSearch());
            reset();
            setActiveStep(0);
            if (submit) {
              navigate(
                `/preauthorization/preauthorization-list/view/${response?.data?.preauth_id}?claim_type=${response?.data?.claim_type}`
              );
            } else {
              navigate("/preauthorization/preauthorization-list");
            }
          } else {
            if (
              response?.message_en?.includes("cURL error 28") ||
              response?.message_en?.includes("Operation timed out")
            ) {
              navigate("/preauthorization/preauthorization-list");
              return;
            } else {
              toast.error(response?.message_en);
            }
          }
        } catch (error) {
          console.error("Submission failed:", error);
          toast.error(error.message || "Submission failed. Please try again.");
        }
      } else {
        // Update Redux store with latest data
        dispatch(handlePreauthFormData({ check: "save", data }));
        setActiveStep((prev) => prev + 1);
      }
    }
  };

  const handlePrevious = () => {
    clearErrors();
    dispatch(clearValidationErrors());
    // dispatch(clearValidationWarning());

    setActiveStep((prev) => Math.max(0, prev - 1));
  };
  const isNextButtonDisabled =
    (steps[activeStep]?.label === "Diagnosis" &&
      (reuse || edit || followUp) &&
      preauthorizationDiagnosis?.length === 0) ||
    (steps[activeStep]?.label === "Triage Assessment" &&
      (reuse || edit || followUp) &&
      (discharegSpeciality?.length ?? 0) === 0 &&
      (encounterStatusList?.length ?? 0) === 0 &&
      (missingTeethList?.length ?? 0) === 0 &&
      (dischargeDispositionList?.length ?? 0) === 0 &&
      (encounterClass?.length ?? 0) === 0) ||
    (steps[activeStep]?.label === "Services & Procedures" &&
      (reuse || edit || followUp) &&
      servicesList?.length === 0) ||
    (steps[activeStep]?.label === "Pre-authorization Request" &&
      (reuse || edit || followUp) &&
      practitionerListAdded?.length === 0);

  return (
    <>
      <div className="p-0 d-flex flex-column g-3">
        {Number(preauthorizationSetting?.add) === 1 && (
          <Form onSubmit={handleSubmit(handleNext)}>
            <FalconComponentCard className="p-0 m0">
              <AnimatePresence mode="wait">
                <motion.div
                  key={`header-${activeStep}`} // helps animate on step change
                  initial={{ opacity: 0, y: -50 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -50 }}
                  transition={{ duration: 0.4 }}
                >
                  <FalconComponentCard.Header className="fixed-header">
                    <Row className="w-100 justify-content-between align-items-center g-2">
                      <BackButton
                        path={paths.preauthorizationList}
                        title={`${isPrescription
                          ? "Prescription Request"
                          : "Pre-authorization Request"
                          } (${steps[activeStep]?.label})`}
                      />

                      <Col
                        xs={12}
                        md="auto"
                        className="d-flex justify-content-center justify-content-md-end gap-2"
                      >
                        {activeStep > 0 && (
                          <Button
                            size="sm"
                            type="button"
                            variant="outline-secondary"
                            onClick={handlePrevious}
                          >
                            Back
                          </Button>
                        )}

                        {!isLastStep ? (
                          <Button
                            size="sm"
                            type="submit"
                            name="action"
                            value="next"
                            variant="success"
                            disabled={isNextButtonDisabled}
                          >
                            Next
                          </Button>
                        ) : (
                          <>
                            {settingData?.[0]?.fieldsetting_txt?.sve_preauth ==
                              1 && (
                                <Button
                                  size="sm"
                                  type="submit"
                                  name="action"
                                  value="save"
                                  variant="warning"
                                  onClick={() => setSubmit(false)}
                                >
                                  Save
                                </Button>
                              )}
                            <Button
                              size="sm"
                              type="submit"
                              name="action"
                              value="submit"
                              onClick={() => setSubmit(true)}
                              variant="success"
                            >
                              Submit
                            </Button>
                          </>
                        )}
                      </Col>
                    </Row>
                  </FalconComponentCard.Header>
                </motion.div>
              </AnimatePresence>

              <FalconComponentCard.Body className="p-3">
                <Row>
                  {/* Form Content (Left to Right) */}
                  <Col xs={12} className="d-lg-none mb-3">
                    <VerticalStepper steps={steps} activeStep={activeStep} />
                  </Col>
                  <Col xs={12} lg={9}>
                    <AnimatePresence mode="wait">
                      <motion.div
                        key={activeStep}
                        initial={{ opacity: 0, x: -100 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -100 }}
                        transition={{ duration: 0.5 }}
                      >
                        {(() => {
                          const StepComponent = steps[activeStep]?.component;
                          const stepProps = steps[activeStep]?.props;
                          return StepComponent ? (
                            <StepComponent {...stepProps} />
                          ) : (
                            ""
                          );
                        })()}
                        <ShowError
                          errors={errors}
                          validationErrors={validationErrors}
                        />
                        <ShowWarning validationWarning={validationWarning} />
                      </motion.div>
                    </AnimatePresence>
                  </Col>

                  {/* Stepper (Right to Left) */}
                  <Col xs={12} lg={3} className="d-none d-lg-block">
                    <AnimatePresence mode="wait">
                      <motion.div
                        key={activeStep} // important to re-trigger animation
                        initial={{ opacity: 0, x: 100 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 100 }}
                        transition={{ duration: 0.5 }}
                        className="position-sticky"
                        style={{ top: "1rem" }}
                      >
                        <VerticalStepper
                          steps={steps}
                          activeStep={activeStep}
                        />
                      </motion.div>
                    </AnimatePresence>
                  </Col>
                </Row>
              </FalconComponentCard.Body>
            </FalconComponentCard>
          </Form>
        )}

        {Number(preauthorizationSetting?.add) !== 1 && !preauthId && (
          <div className="py-6 text-center border rounded-3mb-3">
            <h5 className="text-danger">Permission Denied</h5>
            <p className="text-muted fs-11">
              You do not have permission to add new preauthorizations.
            </p>
          </div>
        )}

        {Number(preauthorizationSetting?.view) !== 1 && preauthId && (
          <div className="py-6 text-center border rounded-3mb-3">
            <h5 className="text-danger">Permission Denied</h5>
            <p className="text-muted fs-11">
              You do not have permission to view preauthorization details.
            </p>
          </div>
        )}
        <MedicalHistoryMOdal
          show={historyModalOpen}
          onHide={() => dispatch(setHistoryModal(false))}
        />
        {validationErrors?.length === 0 && (
          <WarningChild
            modal={showWarningModal}
            setModal={setShowWarningModal}
            title={"Warning Diagnosis"}
            description={"This Diagnosis is rare to use with this patient age."}
            onConfirm={() => setActiveStep(activeStep + 1)}
            onCancel={() => setActiveStep(activeStep)}
          />
        )}
      </div>
    </>
  );
};

export default Preauthorization;
